import React from "react";
import { useNavigate, Outlet, NavLink } from "react-router-dom";
import { clearSession } from "./session";
import "./admin-layout.css";

const AdminLayout = () => {
    const navigate = useNavigate();

    const logout = () => {
        clearSession();
        navigate("/admin/login", { replace: true });
    };

    const getNavClass = ({ isActive }) =>
        isActive ? "nav-link active" : "nav-link";

    return (
        <div className="admin-shell">
            <aside className="admin-aside">
                <div className="brand">OQ SAROY · Admin</div>

                <nav className="admin-nav">
                    <NavLink to="/admin" end className={getNavClass}>
                        <span className="icon">🏠</span>
                        Главная
                    </NavLink>

                    <NavLink to="/admin/doctors" className={getNavClass}>
                        <span className="icon">👨‍⚕️</span>
                        Врачи
                    </NavLink>

                    <NavLink to="/admin/news" className={getNavClass}>
                        <span className="icon">📰</span>
                        Новости
                    </NavLink>
                </nav>

                <button className="logout" onClick={logout}>
                    Выйти
                </button>
            </aside>

            <main className="admin-main">
                <Outlet />
            </main>
        </div>
    );
};

export default AdminLayout;
